/* eslint-disable no-unused-vars */
import { useState } from "react";
import DialogWithCustomComponent from "../mui/dialogWithCustomView";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

export default function ConfirmationDialog({
  visible,
  onNoClick,
  onYesClick,
  title,
}) {
  const [dialogMessage, setDialogMessage] = useState("");
  function handleNoClick() {
    onNoClick();
  }
  function handleYesClick() {
    onYesClick(dialogMessage);
  }
  const handleClose = () => {
    // Optional: Handle dialog close event if needed
  };

  return (
    <Dialog open={visible ?? false} onClose={handleClose}>
      <DialogTitle>{title ?? "No Title"}</DialogTitle>
      <DialogContent>
        <div className="flex m-2 w-96">
          <TextField
            id="dialog_msg"
            label={"Message"}
            placeholder="Type Value"
            multiline
            rows={10}
            fullWidth
            value={dialogMessage}
            onChange={(e) => {
              setDialogMessage(e.target.value);
            }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleNoClick} color="success">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleYesClick}
          color="error"
          autoFocus
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
